import * as React from "react";
import { useRouter } from "next/router";
import {
  IOfferModeWithFSecure,
  useOfferModeWithFsecureWithoutFallback,
} from "@nju/data-access-portal-offers";
import { portalRoutes } from "@nju/routes";

export function RespectMode({
  mode,
  ...props
}: {
  mode: IOfferModeWithFSecure | IOfferModeWithFSecure[];
  children:
    | React.ReactChild
    | ((props: { mode: IOfferModeWithFSecure }) => React.ReactChild);
}) {
  const router = useRouter();
  const currentMode = useOfferModeWithFsecureWithoutFallback();
  const [isOk, setIsOk] = React.useState(false);
  const [currentModeWithFallback, setCurrentModeWithFallback] =
    React.useState<IOfferModeWithFSecure>();

  React.useEffect(() => {
    let resolvedMode: IOfferModeWithFSecure | undefined = currentMode;

    if (!resolvedMode) {
      resolvedMode =
        (window.sessionStorage.getItem(
          "onboardingMode",
        ) as IOfferModeWithFSecure | null) || "ftth";
    }

    setCurrentModeWithFallback(resolvedMode);

    if (
      Array.isArray(mode) ? mode.includes(resolvedMode) : mode === resolvedMode
    ) {
      setIsOk(true);
    } else {
      router.push(portalRoutes.mojeKonto.index.get({ mode: resolvedMode }));
    }

    return () => {
      if (resolvedMode) {
        window.sessionStorage.setItem("onboardingMode", resolvedMode);
      }
    };
  }, [currentMode, mode, router]);

  return isOk && currentModeWithFallback ? (
    <>
      {typeof props.children === "function"
        ? props.children({ ...props, mode: currentModeWithFallback })
        : props.children}
    </>
  ) : // eslint-disable-next-line unicorn/no-null
  null;
}
